export default __webpack_public_path__ + "static/media/mernstack.4c8de8b4.png";